import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class AwpVoipApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }

  // da sostituire con api dashboard
  Get_VOIPResult (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPResult`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPDetails (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPDetails/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPSediA (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPSediA`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPSediB (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPSediB`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_rakerList (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/rakerList`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPGantt (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPGantt`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_jobList (idraker): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/jobList/${idraker}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPInstallationResult (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPInstallationResult/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPCessazioniResult (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPCessazioniResult/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPGlobalReport (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPGlobalReport`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPClassificationArea (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPClassificationArea`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPAvgInstallation (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPAvgInstallation/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_FilesFlussiVoip (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_FilesFlussiVoip`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPFaxServer (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPFaxServer`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPResultLinee (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPResultLinee`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPGlobalLinee (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPGlobalLinee`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPTotaliDirettive (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPTotaliDirettive`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPTotaliDirettiveSedi (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPTotaliDirettiveSedi`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPStato (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPStato`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  DowloadFile (filename): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/download/${filename}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  DowloadFile_byId (idjob): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/download_byId/${idjob}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPDetailsWFLinee (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPDetailsWFLinee/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  /** Apparati, linee, sonde 2N e fax server della sede in un'unica risposta. */
  Get_VOIPSiteDetails (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPSiteDetails/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPRiepilogoESIT (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPRiepilogoESIT`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPGiornalieroESIT (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPGiornalieroESIT`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPMonitoring (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPMonitoring`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPReqPortability (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPReqPortability`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPReqCessazioni (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPReqCessazioni`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPCheckWF (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPCheckWF`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPNPFastweb (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPNPFastweb`
    return this.http.post(APIEndPoint, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Get_VOIPMigrazioniFastweb (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPMigrazioniFastweb/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_VOIPPercMigrazioniFastweb (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpVOIP/Get_VOIPPercMigrazioniFastweb`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }
}
